import React from 'react';

import { MoreHorizontal } from 'lucide-react';

import Button from 'common/uiV3/Button';
import DropdownMenu from 'common/uiV3/DropdownMenu';

import type { Roadmap } from 'common/api/endpoints/roadmaps';

type Props = {
  onArchiveRoadmap: () => void;
  onDeleteRoadmap: () => void;
  onDuplicateRoadmap: () => void;
  onRenameRoadmap: () => void;
  roadmaps: Roadmap[];
  loading: boolean;
};

const AdminRoadmapHeaderOptionsMenu = ({
  onArchiveRoadmap,
  onDeleteRoadmap,
  onDuplicateRoadmap,
  onRenameRoadmap,
  roadmaps,
  loading,
}: Props) => {
  const canDeleteOrArchive = roadmaps?.length > 1;

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger>
        <Button
          disabled={loading}
          aria-label="Roadmap options"
          variant="plain"
          isLoading={loading}
          iconOnly>
          <MoreHorizontal />
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        <DropdownMenu.Item label="Archive" onSelect={onArchiveRoadmap} />
        <DropdownMenu.Item label="Duplicate" onSelect={onDuplicateRoadmap} />
        <DropdownMenu.Item label="Rename" onSelect={onRenameRoadmap} />
        {canDeleteOrArchive && (
          <DropdownMenu.Item label="Delete" variant="destructive" onSelect={onDeleteRoadmap} />
        )}
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default AdminRoadmapHeaderOptionsMenu;
